<ng-container *ngTemplateOutlet="outletTemplate"></ng-container>
